export class GcpRestoreAccountConnectivityConfig {
    'networkConfigs';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networkConfigs",
            "baseName": "networkConfigs",
            "type": "Array<GcpNetworkConnectivityConfig>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpRestoreAccountConnectivityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
